document.addEventListener("DOMContentLoaded", () => {
  console.log("Header script loaded");

  // menu-buttonのクリックイベントを設定
  const menuButton = document.getElementById("menu-button");
  const headerLabel = document.querySelector(".header__label");

  if (menuButton) {
    menuButton.addEventListener("click", () => {
      menuButton.classList.toggle("active");

      // header__label要素にもopenクラスをトグル
      if (headerLabel) {
        headerLabel.classList.toggle("open");
      }
    });
  }
});
